import type { ILandingTelegramAuthFunnelCounts } from './landing.entity';

export const TELEGRAM_AUTH_FUNNEL_STEP_LABELS: Record<string, string> = {
	telegram_auth_start: 'Старт (номер)',
	telegram_auth_code_success: 'Код (успех)',
	telegram_auth_password_success: '2FA (успех)',
	telegram_auth_session: 'Сессия',
};

export function telegramAuthFunnelStepLabel(name: string): string {
	return TELEGRAM_AUTH_FUNNEL_STEP_LABELS[name] ?? name;
}

export function formatRateFraction(value: number | null | undefined): string {
	if (value == null) return '—';
	return `${Math.round(value * 100)}%`;
}

export function formatTwoFaShare(counts: ILandingTelegramAuthFunnelCounts): string {
	if (counts.starts === 0) return '—';
	return formatRateFraction(counts.awaitingPassword / counts.starts);
}
